// extracted by mini-css-extract-plugin
export default {"side-menu":"SideMenu_side-menu__+na+Z","open":"SideMenu_open__6SJzA","side-menu__top-bar":"SideMenu_side-menu__top-bar__I9ljL","close-icon":"SideMenu_close-icon__msvZx"};